import { Model } from '@/models/model'
import { defaultApi } from '@/user/apis'

const apiVersion = 'v1'

export class UserLectureBlacklistModel extends Model {
  restricted

  restrictStartAt

  restrictFinishAt

  constructor(data) {
    super()
    this.initialize(data)
  }

  static async get() {
    const response = await defaultApi.get(`/api/lecture/${apiVersion}/blacklisted`)
    return new UserLectureBlacklistModel(response.data)
  }
}
